import {
  SET_ORG_ID,
  SET_DEFAULT_ORG_ID,
  SET_SUBAPP_ORG_IDS,
  SET_SUBORGS_ALLOWED,
} from 'common/types';

const initialState = {
  orgId: '',
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [SET_ORG_ID]: (state, action) => {
    return {
      ...state,
      orgId: action.payload,
    };
  },
  [SET_DEFAULT_ORG_ID]: (state, action) => {
    return {
      ...state,
      defaultOrgId: action.payload,
    };
  },
  [SET_SUBAPP_ORG_IDS]: (state, action) => {
    return {
      ...state,
      subAppOrgIds: action.payload,
    };
  },
  [SET_SUBORGS_ALLOWED]: (state, action) => {
    return {
      ...state,
      suborgsAllowed: action.payload,
    };
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
export default (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};
